var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "mask0_197_782",
  style: {
    "maskType": "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 16,
  height: 16
}, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  fill: "#D9D9D9"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_197_782)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.99984 10.6666L4.6665 7.33329L5.59984 6.36663L7.33317 8.09996V2.66663H8.6665V8.09996L10.3998 6.36663L11.3332 7.33329L7.99984 10.6666ZM3.99984 13.3333C3.63317 13.3333 3.31928 13.2027 3.05817 12.9416C2.79706 12.6805 2.6665 12.3666 2.6665 12V9.99996H3.99984V12H11.9998V9.99996H13.3332V12C13.3332 12.3666 13.2026 12.6805 12.9415 12.9416C12.6804 13.2027 12.3665 13.3333 11.9998 13.3333H3.99984Z",
  fill: "#597EF7"
}))));
export default __webpack_public_path__ + "teg/media/download-new.cfcb7e35.svg";
export { SvgComponent as ReactComponent };